/* Hook encargado de hacer la consulta a la base y 
traer los negocios )deals)

Autor: Benjamín León
Fecha: 2024-11-09
*/
import { useState } from 'react'

import { customFetch } from '../utils/customFetch.ts'
import { Estimate } from '../interfaces/Estimate.ts'

import { makeUrlEstimatesDeal } from './connectionData.tsx'

const useEstimatesDealFetcher = () => {
  const [errorEstimatesDeal, setErrorEstimatesDeal] = useState<Error | null>(null)
  const [loading, setLoading] = useState<boolean>(false)

  const fetchEstimatesDeal = async (vehId: string, cliId: string) => {
    setLoading(true)

    const params = new URLSearchParams({
      vehId: vehId,
      cliId: cliId,
    })

    try {
      const apiUrl = makeUrlEstimatesDeal(params)
      const array = await customFetch<Estimate[]>(apiUrl)

      setErrorEstimatesDeal(null)

      return array
    } catch (err) {
      // Assert the error as an instance of Error
      const myErr = err instanceof Error ? err : new Error('An unknown error occurred')
      setErrorEstimatesDeal(myErr)

      return []
    } finally {
      setLoading(false)
    }
  }

  // Exponemos estas variables al exterior
  return { errorEstimatesDeal, loading, fetchEstimatesDeal }
}
export default useEstimatesDealFetcher
